const logs = {
    page_title: '감사 기록',
    title: '감사 기록',
    subtitle: '관리자나 사용자의 인증 기록을 확인해 보세요.',
    event: '활동',
    user: '사용자',
    application: '어플리케이션',
    time: '시간',
    filter_by: '필터',
    last_1_hour: '최근 1시간',
    last_24_hours: '최근 24시간',
    last_7_days: '최근 7일',
    last_30_days: '최근 30일',
    custom_range: '사용자 지정 범위',
    from: '시작',
    to: '종료',
};
export default Object.freeze(logs);
